import Button from './Button';
export { Label, Text } from './Button';

export default Button;
